"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconCoachmark = void 0;
var react_1 = __importStar(require("react"));
var spaui_utils_1 = require("@tencent/spaui-utils");
var info_1 = __importDefault(require("./info"));
var spaui_1 = require("@tencent/spaui");
var IconCoachmark = function IconCoachmark(props) {
  return react_1["default"].createElement("svg", __assign({
    fill: "currentColor",
    width: 36,
    height: 36,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), react_1["default"].createElement("circle", {
    opacity: "0.1",
    transform: "matrix(1, 0, 0, -1, 18, 18)",
    r: 18
  }), react_1["default"].createElement("circle", {
    opacity: "0.2",
    transform: "matrix(1, 0, 0, -1, 18, 18)",
    r: 14
  }), react_1["default"].createElement("circle", {
    opacity: "0.3",
    transform: "matrix(1, 0, 0, -1, 18, 18)",
    r: 10
  }), react_1["default"].createElement("circle", {
    transform: "matrix(1, 0, 0, -1, 18, 18)",
    r: 6
  }));
};
exports.IconCoachmark = IconCoachmark;
var CoachmarkComponent = react_1["default"].forwardRef(function (props, ref) {
  var target = props.target,
    _a = props.color,
    color = _a === void 0 ? 'var(--spaui-brand-color)' : _a,
    icon = props.icon;
  var dom = react_1["default"].createElement("div", __assign({}, (0, spaui_utils_1.globalProps)(props, {
    withDefaultClassName: false,
    className: 'odc-coachmark absolute',
    supportAllEvents: true,
    ref: ref
  }, CoachmarkComponent)), react_1["default"].createElement("i", {
    className: "odc-coachmark-icon flex items-center justify-center cursor-pointer",
    "aria-hidden": "true",
    onMouseEnter: function onMouseEnter(e) {
      return e.target.style.animationPlayState = 'paused';
    }
  }, !icon ? react_1["default"].createElement(exports.IconCoachmark, {
    className: "odc-coachmark-svg pointer-events-none",
    color: color
  }) : icon));
  return react_1["default"].createElement(spaui_1.Portal, {
    target: target
  }, dom);
});
CoachmarkComponent.displayName = 'Coachmark';
(0, spaui_utils_1.setComponentMark)(CoachmarkComponent, info_1["default"]);
exports["default"] = (0, react_1.memo)(CoachmarkComponent);